/**
 *
 * CardDataItem
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { Content, IconContainer, Item, Label } from './CardData.styles';
import Skeleton from '../Skeleton';
import TextNoWrap from '../TextNoWrap';

const CardDataItem = ({
  alignTop,
  content,
  icon,
  iconColor = null,
  iconStrokeColor = null,
  inline,
  label,
  isPreview,
  isMultiline,
  previewLines,
  labelStyles,
  ...props
}) => {
  const shouldTruncate = !isMultiline && !isPreview;

  return (
    <Item
      $alignTop={alignTop}
      disablePadding
      $inline={inline}
      component={inline ? 'span' : 'li'}
      {...props}
    >
      {icon && (
        <IconContainer $color={iconColor} $iconStrokeColor={iconStrokeColor}>
          {icon}
        </IconContainer>
      )}
      {content && (
        <Content
          $isPreview={isPreview}
          $previewLines={previewLines}
          disableTypography
        >
          {shouldTruncate ? (
            <TextNoWrap showTooltipOnOverflow>{content}</TextNoWrap>
          ) : (
            content
          )}
        </Content>
      )}
      {!content && <Skeleton />}
      {label && <Label style={labelStyles}>{label}</Label>}
    </Item>
  );
};

CardDataItem.propTypes = {
  alignTop: PropTypes.bool,
  isPreview: PropTypes.bool,
  isMultiline: PropTypes.bool,
  previewLines: PropTypes.number,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.node,
  iconColor: PropTypes.string,
  iconStrokeColor: PropTypes.string,
  inline: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelStyles: PropTypes.object,
};

export default memo(CardDataItem);
